import { render, staticRenderFns } from "./acceptAgreement.vue?vue&type=template&id=056eb6db&"
import script from "./acceptAgreement.vue?vue&type=script&lang=js&"
export * from "./acceptAgreement.vue?vue&type=script&lang=js&"
import style0 from "./acceptAgreement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCheckbox,VCol,VProgressCircular})
